<template>
  <footer v-if="!hideFooter" class="footer-main font-white background-black">
    <FooterNewsletter />

    <FooterMenu />

    <FooterBottom />
  </footer>
</template>

<script setup>
const route = useRoute()

const hideFooter = computed(() => {
  return route.meta?.hideFooter === true
})
</script>

<style lang="scss">
@import './style.scss';
</style>
